import Vue from 'vue'
import VueFuse from 'vue-fuse'
import Vuebar from 'vuebar'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import VueClipboard from 'vue-clipboard2'

import router from './router'
import store from './store/index.js'
import ValidatorLite from './plugin/validate'
import toastPlugin from './components/toast'
import loginPlugin from './components/quick-login'
import modal from './components/modal'
import loading from './components/loading'
import Paginate from './components/paginate'
import Dropdown from './components/dropdown'
import VTooltip from 'v-tooltip'
import * as filters from './filters'

import './common/array'
import 'swiper/dist/css/swiper.css'
import './assets/style/sprite.css'
import './assets/style/common.scss'
import '../static/ueditor/ueditor.config'
import '../static/ueditor/ueditor.all'
import '../static/ueditor/lang/zh-cn/zh-cn'
import '../static/ueditor/ueditor.parse'

Vue.use(Vuebar)
Vue.use(VueAwesomeSwiper)
Vue.use(toastPlugin)
Vue.use(ValidatorLite)
Vue.use(modal)
Vue.use(loading)
Vue.use(Paginate)
Vue.use(Dropdown)
Vue.use(VueFuse)
Vue.use(loginPlugin)
Vue.use(VTooltip)
Vue.use(VueClipboard)

Object.keys(filters).forEach( key => {
    Vue.filter(key, filters[key])
})

Vue.config.productionTip = false
new Vue({
    router,
    store
}).$mount('#app')


// WEBPACK FOOTER //
// ./src/main.js